import { gql } from "@apollo/client";

const claimOrderProductionJobCustomizationAreaMutation =  gql`
  mutation($orderProductionJobCustomizationAreaId: ID!) {
    claimOrderProductionJobCustomizationArea(
      orderProductionJobCustomizationAreaId: $orderProductionJobCustomizationAreaId
    ) {
      createdOrderProductionJobCustomizationAreaClaim {
        id
      }
      errors {
        orderProductionJobCustomizationAreaId
      }
      succeeded
      updatedOrderProductionJobCustomizationArea {
        id
      }
    }
  }
`;

export default claimOrderProductionJobCustomizationAreaMutation;
